import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, EmptyCollection, ExportMenu, FilterComponent, ImportMenu, PageLoader, Pagination, STableLoader, } from "../../../shared_elements";
import RegionTableList from "../components/RegionTableList";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import AddEditRegion from "../components/AddEditRegion";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
const RegionObj = {
	name: null,
	remarks: null,
}

const RegionHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
	return (
		<TableHead>
			<TableRow >
				<TableCell >{checkPermission('config_data', 'region', 'D') && <Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'name' ? true : false}
						direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('name')}
					>
						Name
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'created_by' ? true : false}
						direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('created_by')}
					>
						Created By
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'updated_by' ? true : false}
						direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('updated_by')}
					>
						Last Updated By
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'remarks' ? true : false}
						direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('remarks')}
					>
						Remarks
					</TableSortLabel>
				</TableCell>
			</TableRow>
		</TableHead>
	)
}

const Region = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [isLoading, setLoading] = useState(false);
	const [filter, setFilter] = useState({});
	const [pageSelections, setPageSelections] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
	const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
	const [addEditRegion, setAddEditRegion] = useState({ modal: false, data: null });
	const [deleteRegion, setDeleteRegion] = useState({ modal: false, data: null });
	const [revertRegion, setRevertRegion] = useState({ modal: false, data: null });
	const [regionInfo, setRegionInfo] = useState({list:[], pagination:{}});

	useEffect(() => {
		getRegion({per_page:50},"skeletonLoader");
		trackActivity('Console Management', { page_title: 'Config Data : Region', event_type: 'Page Visited' })
	}, [])


	const getRegion = (query = {}, loaderType) => {
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
		globalGetService(`config-data/region/`, query)
			.then(response => {
				if (checkApiStatus(response)) {
					setRegionInfo(response.data.data)
					if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
			})
	}

	const toggleBulkOps = (item, checked, currentPage) => {
		setPageSelections(prevSelections => {
			const updatedSelections = { ...prevSelections };
			if (checked) {
				updatedSelections[currentPage] = updatedSelections[currentPage] || [];
				updatedSelections[currentPage].push(item?.id);
			} else {
				updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
			}
			return updatedSelections;
		});
	};

	const onDelete = () => {
		setLoading(true);
		const ids = !deleteRegion.data ? Object.values(pageSelections).flat().filter(id => {
			const item = regionInfo.list.find(item => item.id === id);
			return item && !item.deleted_at;
		}) : deleteRegion.data.id

		globalDeleteService(`config-data/region/bulk-delete/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setDeleteRegion({ modal: false, data: null });
					getRegion({...filter, page: regionInfo?.pagination?.page, per_page: regionInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', { page_title: 'Config Data : Region', event_type: `Item Deleted`, event_desc: 'Region Deleted Successfully', success_msg: response?.data?.message, deleted_id: ids });
				} else {
					setDeleteRegion({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', { page_title: 'Config Data : Region', event_type: `Item Deleted`, event_desc: 'Region Deletion Failed', error_msg: response?.data?.message, item_id: ids });
				}
			});
	};

	const onRevert = () => {
		setLoading(true);
		const ids = !revertRegion.data ? Object.values(pageSelections).flat().filter(id => {
			const item = regionInfo.list.find(item => item.id === id);
			return item && item.deleted_at;
		}) : revertRegion.data;

		globalPutService(`config-data/region/restore/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setRevertRegion({ modal: false, data: null });
					getRegion({...filter, page: regionInfo?.pagination?.page, per_page: regionInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', { page_title: 'Config Data : Region', event_type: `Item Reverted`, event_desc: 'Region Reverted Successfully', success_msg: response?.data?.message, reverted_id: ids });
				} else {
					setRevertRegion({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', { page_title: 'Config Data : Region', event_type: `Item Reverted`, event_desc: 'Region Reversion Failed', error_msg: response?.data?.message, item_id: ids });
				}
			});
	};

	const handleSelectAll = (event, currentPage) => {
		if (event?.target.checked) {
			const allIds = regionInfo?.list.map(item => item.id);
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
		} else {
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
		}
	};

	const getFilteredSelectionCounts = () => {
		let deleteCount = 0;
		let revertCount = 0;
		if (pageSelections[currentPage]?.length) {
			pageSelections[currentPage].forEach(id => {
				const selectedItem = regionInfo?.list?.find(item => item?.id === id);
				if (selectedItem) {
					if (selectedItem?.deleted_at) {
						revertCount++;
					} else {
						deleteCount++;
					}
				}
			});
		}
		return { deleteCount, revertCount };
	};

	const { deleteCount, revertCount } = getFilteredSelectionCounts();

	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		getRegion({ ...filter, ...sortQuery, page: 1, per_page: regionInfo?.pagination?.per_page || 20 }, 'pageLoader');
	}

	const isSelectAllChecked = regionInfo?.list?.length > 0 && pageSelections[currentPage]?.length === regionInfo?.list?.length;

	const getConfirmColor = () => {
        if (revertRegion?.modal || bulkRevert?.modal) return "primary";
        if (deleteRegion?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertRegion?.modal || bulkRevert?.modal) return "Revert";
        if (deleteRegion?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertRegion?.modal) return revertRegion.modal;
        if (deleteRegion?.modal) return deleteRegion.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertRegion?.modal) return "Revert Region";
        if (deleteRegion?.modal) return "Delete Region";
        if (bulkDelete?.modal) return `Delete Region (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Region (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertRegion?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteRegion?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertRegion?.modal) {
            setRevertRegion({ modal: false, data: null });
        } else if (deleteRegion?.modal) {
            setDeleteRegion({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertRegion?.modal || bulkRevert?.modal) return onRevert;
        if (deleteRegion?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

	const filterOption = (
		{
			'name': {
				'inputType': 'text',
				'title': 'Name',
			},
		})

	return (
		<section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
			<Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
				<ConfigData />
				<div className="tech-specs-content" style={{ paddingTop: '0px' }}>
				{skeletonLoader ? <STableLoader count={6} size={9} /> :
					<div style={{ padding: '10px' }}>
						<Paper className="console-paper" elevation={0} style={{ padding: '4px 8px', marginBottom: "2px" }}>
							<Grid container spacing={1} alignItems="center">
									<Grid item md={6}>
											<FilterComponent
												filter={filter}
												filterMenu={filterOption}
												getResponseBack={(applyFilter) => { getRegion({ ...applyFilter, page: 1, per_page: regionInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
											/>
									</Grid>
								<Grid item md={6}>
									<ul className='list-inline flex-centered' style={{ float: 'right' }}>
										{revertCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Region', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Region` }) }} color="primary" size='small' variant="outlined">
													Revert ({revertCount})
												</Button>
											</li>
										)}
										{deleteCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Region', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Region` }) }} color="secondary" size='small' variant="contained">
													Delete ({deleteCount})
												</Button>
											</li>
										)}
										{checkPermission('config_data', 'region', 'C') && <li className='list-inline-item'>
											<Button onClick={() => setAddEditRegion({ modal: true, data: RegionObj })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
										</li>}
										
									</ul>
								</Grid>
							</Grid>
						</Paper>
						<Paper square>
						  <div style={{ height: `${window.innerHeight - (regionInfo?.list?.length ? 200 : 150)}px`, overflow: 'auto' }}>
							<Table className='mui-table-format' stickyHeader>
								<RegionHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
									<TableBody>
										{regionInfo?.list?.length > 0 && regionInfo?.list?.map((item, index) =>
											<RegionTableList
												item={item}
												index={index}
												onDelete={setDeleteRegion}
												onRevert={setRevertRegion}
												onEditFn={() => setAddEditRegion({ modal: true, data: item, type: 'edit' })}
												onViewFn={() => setAddEditRegion({ modal: true, data: item, type: 'view' })}
												toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
												bulkIds={pageSelections[currentPage] || []}
											/>
										)}
									</TableBody>
							 </Table>
							  {!regionInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
							</div>
						</Paper>
						<Paper square>
							<Pagination
								pagination={regionInfo?.pagination}
								onChangePage={(event, newPage) => { getRegion({ ...filter, page: newPage + 1, per_page: regionInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
								onChangeRowsPerPage={(event) => getRegion({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
							/>
						</Paper>
					</div>}
				</div>
				{addEditRegion.modal ?
					<AddEditRegion
						addEditRegion={addEditRegion}
						regionInfo={regionInfo}
						toggleModalFn={() => setAddEditRegion({ modal: false, regionData: [] })}
						getResponseBack={() => getRegion({...filter, page: regionInfo?.pagination?.page, per_page: regionInfo?.pagination?.per_page}, 'pageLoader')}
						modeType={addEditRegion?.type}
					/> : null
				}
				<DeletePopUp
					confirmColor={getConfirmColor()}
					confirmText={getConfirmText()}
					modal={getModal()}
					title={getTitle()}
					content={getContent()}
					toggleModalFn={toggleModalFn}
					deleteRecordFn={getDeleteRecordFn()}
				/>
			</Paper>
			{isLoading ? <PageLoader /> : null}
		</section>
	)
}
export default Region;